
import LoadingIndicator from "./LoadingIndicator";
const LoadingIndicatorTransparent = ()=>{

    return(<div style={{position:"fixed",width:"100vw",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center",left:0,top:0,background:"rgba(255,255,255,0.3)",zIndex:"9999"}}>
        <LoadingIndicator label={'Loading'}/>
    </div>);
}

export default LoadingIndicatorTransparent;